module.exports = __webpack_public_path__ + "static/media/aktenschrank.b44942ca.svg";